'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.ListActionsToolbar', []).controller('ListActionsToolbarController', require('./controllers/ListActionsToolbarController')).directive('rmListActionsToolbar', require('./directives/ListActionsToolbarDirective'));